import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { fetchActivities } from "src/redux/slices/activities";
import PageHero from "src/sections/components/page-hero";
import RequestCta from "src/sections/components/request-cta";
import { TourSection } from "src/sections/activities/components/tour-section";
import PhotoBand from "src/sections/components/photo-band";
import TourFilters, { useTourFilters } from "./tour-filters";
import Footer from "../../components/footer/footer";
import { usePageMeta } from "src/utils/seo";

const AllActivities = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  usePageMeta({
    title: t("actPage.title"),
    description: t("actPage.subtitle"),
  });
  const activities = useSelector((state) => state.activities.activities.items);

  useEffect(() => {
    dispatch(fetchActivities());
  }, [dispatch]);

  // Фильтр стоит ПЕРЕД разделением на «с датами» и «по запросу»: сначала
  // отбираем туры по строке поиска, потом раскладываем их по двум блокам.
  const filters = useTourFilters(activities);
  const hot = filters.filtered.filter((a) => a?.date);
  const regular = filters.filtered.filter((a) => !a?.date);
  const nothingFound = filters.active && filters.filtered.length === 0;

  return (
    <div className="min-h-screen w-full flex flex-col justify-between bg-kj-dark text-kj-ink">
      <PageHero
        eyebrow={t("actPage.eyebrow")}
        title={t("actPage.title")}
        subtitle={t("actPage.subtitle")}
      />
      {/* Между шапкой и подвалом страница была ровной тёмной заливкой —
          особенно заметно, когда туров один-два. Фотополоса возвращает в
          середину глубину, оставаясь под текстом и рамками карточек. */}
      <div className="relative">
        <PhotoBand mirrored className="top-24 h-[480px] sm:h-[620px]" />

        <div className="relative z-10 max-w-[1526px] w-full h-full mx-auto flex flex-col gap-y-10 sm:gap-y-14 px-4 mt-10 sm:mt-14 mb-12">
        <TourFilters state={filters} />

        {nothingFound ? (
          // Пустой результат — это тупик, из которого должен быть выход:
          // сбросить фильтр или сразу оставить заявку.
          <div className="rounded-2xl border border-kj-line bg-kj-card/40 px-6 py-12 text-center">
            <p className="text-lg sm:text-xl font-extrabold uppercase tracking-tight text-kj-ink">
              {t("filters.empty")}
            </p>
            <p className="mx-auto mt-2 max-w-[48ch] text-sm sm:text-base text-kj-sub leading-relaxed">
              {t("filters.emptyHint")}
            </p>
            <button
              type="button"
              onClick={filters.reset}
              className="mt-5 inline-flex min-h-[44px] items-center rounded-sm border border-kj-gold px-6 text-xs font-bold uppercase tracking-[0.1em] text-kj-gold transition-colors hover:bg-kj-gold hover:text-kj-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-kj-gold focus-visible:ring-offset-2 focus-visible:ring-offset-kj-dark"
            >
              {t("filters.reset")}
            </button>
          </div>
        ) : (
          <>
            <TourSection
              title={t("activities.hotTitle")}
              subtitle={t("activities.hotSubtitle")}
              tours={hot}
              layout="grid"
            />

            <TourSection
              title={t("activities.regularTitle")}
              subtitle={t("activities.regularSubtitle")}
              tours={regular}
              layout="grid"
            />
          </>
        )}

        <RequestCta />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AllActivities;
